/* tslint:disable:no-var-requires */
import { isServerSide } from '../util/server-side-rendering/is-server-side';

if (!isServerSide()) {
  require('./polyfill');
}
require('./vendor');
